const routeComponents: any = {};
const noComponent = () => null;
export const getComponent = (routeKey: string) => routeComponents[ routeKey ];
export async function fetchComponent( routeKey: string, fetchFunc: () => Promise<any> ) {
    if ( !fetchFunc ) {
        throw new Error( `No import given for ${routeKey}` );
    }

    const module = await fetchFunc() || {};
    routeComponents[ routeKey ] = module.default || noComponent;
    return routeComponents[ routeKey ];
}
